import { defineStore } from "pinia";

import eImage from "@/assets/e.png";
import nImage from "@/assets/n.png";
import neImage from "@/assets/ne.png";
import nwImage from "@/assets/nw.png";
import sImage from "@/assets/s.png";
import seImage from "@/assets/se.png";
import swImage from "@/assets/sw.png";
import unknownImage from "@/assets/unknown.png";
import wImage from "@/assets/w.png";

import { useGoldfishStore } from "./goldfishStore";
import { useHistoryEditorStore } from "./historyEditorStore";
import { useSettingsStore } from "./settingsStore";

export const useWindStore = defineStore("wind", {
    state: () => {
        return {
            wind: {
                directions: [
                    { id: "NW", img: nwImage, goldfishId: 5 },
                    { id: "N", img: nImage, goldfishId: 4 },
                    { id: "NE", img: neImage, goldfishId: 3 },
                    { id: "E", img: eImage, goldfishId: 2 },
                    { id: "SE", img: seImage, goldfishId: 1 },
                    { id: "S", img: sImage, goldfishId: 0 },
                    { id: "SW", img: swImage, goldfishId: 7 },
                    { id: "W", img: wImage, goldfishId: 6 },
                    { id: "?", img: unknownImage, goldfishId: 9 },
                ],
                speeds: [
                    { m_s: 0, mph: 0, color: "#888888" },
                    { m_s: 1, mph: 2, color: "#00a5ff" },
                    { m_s: 2, mph: 4, color: "#0894ff" },
                    { m_s: 3, mph: 6, color: "#3481ff" },
                    { m_s: 4, mph: 8, color: "#5970ff" },
                    { m_s: 5, mph: 10, color: "#6a6cff" },
                    { m_s: 6, mph: 12, color: "#7964ff" },
                    { m_s: 7, mph: 14, color: "#8f53e8" },
                    { m_s: 8, mph: 16, color: "#a648b9" },
                    { m_s: 9, mph: 18, color: "#c53c9d" },
                    { m_s: 10, mph: 20, color: "#c43584" },
                    { m_s: 11, mph: 22, color: "#c22d6b", ogOnly: true },
                    { m_s: 12, mph: 24, color: "#c12452", ogOnly: true },
                    { m_s: 13, mph: 26, color: "#c11b3a", ogOnly: true },
                    { m_s: 14, mph: 28, color: "#c11323", ogOnly: true },
                    { m_s: 15, mph: 30, color: "#c10c0c", ogOnly: true },
                    { m_s: 17, mph: 34, color: "#000000" },
                ],
            },

            usedDirections: [],
            usedSpeeds: [],

            currentPair: [{}, {}, {}],
            history: [],

            zeroDirection: null,
            doAfterZero: null,
        };
    },
    getters: {
        historyLength() {
            //return amount of items in history where item[0] AND item[1] is not empty
            return this.history.filter(
                (item) => item[0] != {} && item[1].m_s != (null || undefined)
            ).length;
        },
        wsrSpeeds() {
            return this.wind.speeds.filter((speed) => !speed.ogOnly);
        },
        goldfishifyHistory() {
            return this.history
                .filter(
                    (pair) =>
                        pair[0] &&
                        Object.keys(pair[0]).length > 0 &&
                        pair[1] &&
                        Object.keys(pair[1]).length > 0
                )
                .map((pair) => {
                    const direction =
                        pair[0].goldfishId !== undefined
                            ? pair[0].goldfishId
                            : 9;
                    const speed = pair[1].m_s !== undefined ? pair[1].m_s : 17;
                    return {
                        direction,
                        speed,
                    };
                });
        },
    },
    actions: {
        handleClick(ev, type, value) {
            const historyEditorStore = useHistoryEditorStore();

            switch (type) {
                case "direction":
                    if (historyEditorStore.currentlyEditingIndex !== null) {
                        historyEditorStore.currentlyEditingDirectionId =
                            value.id;
                    }

                    this.currentPair[0] = value;

                    break;

                case "speed":
                    if (historyEditorStore.currentlyEditingIndex !== null) {
                        historyEditorStore.currentlyEditingSpeedM_s = value.m_s;
                    }

                    this.currentPair[1] = value;

                    break;
            }

            if (
                this.currentPair[0]?.id &&
                this.currentPair[1]?.m_s !== undefined
            ) {
                if (historyEditorStore.currentlyEditingIndex !== null) {
                    historyEditorStore.save();
                    return;
                }

                this.addToHistory(this.currentPair);
            }
        },
        addToHistory(pair) {
            const settingsStore = useSettingsStore();

            if (pair == null || pair == undefined) {
                return;
            }

            //push it to history
            this.history[this.historyLength] = pair;

            if (this.doAfterZero) {
                this.ogAfterZeroWindProcedure();
            }

            //push direction to used directions
            if (!(pair[1].m_s == 0) || !settingsStore.game.startsWith("og")) {
                if (
                    pair[0].id != "?" &&
                    !this.usedDirections.includes(pair[0])
                ) {
                    this.usedDirections.push(pair[0]);
                }
            } else {
                this.ogZeroWindProcedure();
            }

            // push speed to used speeds if not unknown
            if (pair[1].m_s !== 17) {
                this.usedSpeeds.push(pair[1]);
            }

            if (
                this.historyLength == 8 &&
                settingsStore.game.startsWith("og")
            ) {
                this.ogHole8Procedure();
            }

            //clear it
            this.currentPair = [{}, {}, {}];

            if (this.historyLength % 8 == 0 && settingsStore.game == "wsr") {
                //autofilling unknown directions//

                let unknownDirection = this.wind.directions.find(
                    (direction) => direction.id === "?"
                );

                let groupOf8 = this.history.slice(
                    this.historyLength / 8 - 1,
                    this.historyLength / 8 + 7
                );

                //if there is exactly one unknown direction in the group of 8
                if (this.usedDirections.length == 7) {
                    //replace the unknown direction in the history with the only one not inside this.usedDirections
                    let unknownPairIndex = groupOf8
                        .map((pair) => pair[0])
                        .indexOf(unknownDirection);

                    let remainingDirection = this.wind.directions.find(
                        (item) =>
                            !this.usedDirections.includes(item) &&
                            item != unknownDirection
                    );

                    this.history[unknownPairIndex][0] = remainingDirection;
                }

                this.usedDirections = [];
            }

            if (this.historyLength % 9 === 0) {
                this.usedSpeeds = [];
            }

            if (settingsStore.goldfishEnabled) {
                useGoldfishStore().holeLoad();
                useGoldfishStore().findSeed();
            }
        },
        ogZeroWindProcedure() {
            let zeroDirection = this.history[this.historyLength - 1][0];

            if (zeroDirection.id == "?") {
                return;
            }

            if (this.historyLength == 8) {
                this.history[8][0] = zeroDirection;
                return;
            }

            this.history[this.historyLength][0] = zeroDirection;
            this.history[this.historyLength][2].text = `9/16`;

            this.history[8][0] = zeroDirection;
            this.history[8][2].text = `7/16`;

            this.zeroDirection = zeroDirection;

            this.doAfterZero = true;
        },
        ogAfterZeroWindProcedure() {
            let zeroDirection = this.zeroDirection;

            this.usedDirections.push(zeroDirection);

            this.history[8][2] = {};

            if (this.currentPair[0] == zeroDirection) {
                this.history[8][0] = {};
            }

            this.doAfterZero = false;
        },
        ogHole8Procedure() {
            const zeroSpeed = this.wind.speeds.find((speed) => speed.m_s == 0);
            const unusedDirection = this.wind.directions.find(
                (direction) =>
                    !this.usedDirections.includes(direction) &&
                    direction.id != "?"
            );

            const unknownDirection = this.wind.directions.find(
                (direction) => direction.id == "?"
            );

            if (unusedDirection == undefined && this.zeroDirection == null) {
                this.history[8][1] = zeroSpeed;
                this.history[8][0] = unknownDirection;
            } else {
                if (this.usedDirections.length == 7) {
                    if (unusedDirection) {
                        this.history[8][0] = unusedDirection;
                    }
                    this.usedDirections.push(unknownDirection);
                } else if (this.zeroDirection) {
                    // includes everything besides zeroDirection
                    this.usedDirections = this.wind.directions.filter(
                        (direction) => direction != this.zeroDirection
                    );
                }
            }
        },

        reset(resetEditor = true) {
            const historyEditorStore = useHistoryEditorStore();

            this.usedDirections = [];
            this.usedSpeeds = [];
            this.currentPair = [{}, {}, {}];
            this.history = this.createEmptyHistory();
            this.zeroDirection = null;
            this.doAfterZero = null;

            if (resetEditor) {
                historyEditorStore.close();
            }

            historyEditorStore.currentlyEditingIndex = null;
            historyEditorStore.currentlyEditingDirectionId = null;
            historyEditorStore.currentlyEditingSpeedM_s = null;
            historyEditorStore.error = null;

            const goldfishStore = useGoldfishStore();
            goldfishStore.reset();
        },
        createEmptyHistory() {
            const settingsStore = useSettingsStore();

            let history = [];

            for (let i = 0; i < settingsStore.holes; i++) {
                history.push([{}, {}, {}]);
            }

            return history;
        },
    },
});
